import React, { FC, useState } from 'react';
import { makeStyles, Modal } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Footer = styled.p`
  font-size: 13px;
  text-align: center;
  margin: 0;
`;

const TermsOfUseContent: FC = () => {
  const { t } = useTranslation('terms');

  return (
    <div style={{ maxWidth: 400 }}>
      <h1>{t('title')}</h1>
      <p>{t('paragraph1')}</p>
      <p>{t('paragraph2')}</p>
      <p>{t('paragraph3')}</p>
      <p>{t('paragraph4')}</p>
      <p>{t('paragraph5')}</p>
      <p>{t('paragraph6')}</p>
      <p>{t('paragraph7')}</p>
      <p>{t('paragraph8')}</p>
    </div>
  );
};

export const TermsOfUse: FC = () => {
  const { t } = useTranslation('common');
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Footer>
        {`${t('pressingButton')} "${t('send')}", ${t('youAgreeWith')} `}
        <span
          onClick={handleOpen}
          style={{ textDecoration: 'underline', cursor: 'pointer' }}
        >
          {t('termsOfUse')}
        </span>
      </Footer>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.paper}
      >
        <div className={classes.root}>
          {open ? (
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
          <TermsOfUseContent />
        </div>
      </Modal>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    marginLeft: 'auto',
    marginRight: 'auto',
    backgroundColor: theme.palette.background.paper,
    opacity: 0.9,
    padding: theme.spacing(2, 4, 4),
    outline: 'none',
    borderRadius: '20px',
    boxShadow: '0px 4px 100px rgba(0,0,0,0.1)',
    maxWidth: '400px',
    marginTop: '35px',
    marginBottom: '35px'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  paper: {
    overflow: 'scroll'
  }
}));
